
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/detriot-free-press",
      function () {
        return require("private-next-pages/nm/news/detriot-free-press.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/detriot-free-press"])
      });
    }
  